<script setup>
import { SText } from '@n966/soilbox_ui'
</script>

<template>
  <div class="overlay-alert">
    <img
      src="@/assets/images/modal-logo.svg"
      alt=""
    />
    <div class="overlay-alert__text">
      <s-text center>
        Приложение предназначено для работы на больших экранах компьютеров.
        Пожалуйста, откройте приложение на компьютере.
      </s-text>
    </div>
  </div>
</template>

<style lang="scss">
.overlay-alert {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  position: absolute;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: var(--main-bg);

  &__text {
    max-width: 544px;

    & .s-text {
      line-height: 1.75 !important;
    }
  }
}
</style>
